import ContactPage from "components/Form/ContactPage"
import { formIds } from "utils/links"

const formId = formIds.contact

export default function ContactUs() {
	return (
		<ContactPage
			formId={formId}
			formName="contact-us"
			kicker="Get in Touch"
			title="Contact Us"
			subtitle="We'd love to hear from you."
		/>
	)
}
